import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ = () => {
  const { t } = useLanguage();

  const faqs = [
    { q: t('faq1Q'), a: t('faq1A') },
    { q: t('faq2Q'), a: t('faq2A') },
    { q: t('faq3Q'), a: t('faq3A') },
    { q: t('faq4Q'), a: t('faq4A') },
    { q: t('faq5Q'), a: t('faq5A') },
    { q: t('faq6Q'), a: t('faq6A') },
    { q: t('faq7Q'), a: t('faq7A') },
    { q: t('faq8Q'), a: t('faq8A') },
    { q: t('faq9Q'), a: t('faq9A') },
    { q: t('faq10Q'), a: t('faq10A') },
    { q: t('faq11Q'), a: t('faq11A') },
    { q: t('faq12Q'), a: t('faq12A') }
  ];

  return (
    <section className="bg-black py-16 md:py-24 animate-fade-in">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          {t('faqTitle')}
        </h2>
        
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white/5 border border-white/10 px-6 data-[state=open]:border-[#00FFD1]/50 transition-colors"
            >
              <AccordionTrigger className="text-white hover:text-[#00FFD1] text-left py-5 text-base md:text-lg font-medium hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 pb-5 text-base leading-relaxed">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;